import { Property } from './property';

export class AnalyzedProperties {
    constructor(doc) {
        this.analyzedPropertyList = [];

        doc.forEach(property => {
            this.analyzedPropertyList.push(new AnalyzedProperty(property));
        });
    }
}

class AnalyzedProperty extends Property {
    // constructor(doc) {
    //     super(doc);

    // }
}


